








import { Component, Vue, Prop } from "vue-property-decorator";
import FilterComponent from "./Filter.vue";
import { mapState } from 'vuex';

@Component({
  components: {
    FilterComponent
  },
  computed: {
    ...mapState(['filters'])
  },
})
export default class FiltersComponent extends Vue {
    @Prop() public compactView!: boolean;
}
